<template>
  <div class="campaign-page">
    <app-page-header title="Campanhas">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus"></b-icon>NOVO
      </button>
    </app-page-header>

    <campaign-table></campaign-table>
  </div>
</template>

<script>
import CampaignTable from '@/components/Tables/CampaignTable.vue';

export default {
  name: 'campaign-page',
  components: {
    CampaignTable,
  },
  methods: {
    create() {
      this.$router.push('/campaign/create');
    },
  },
};
</script>

<style lang="scss" scoped></style>
